module.exports = __webpack_public_path__ + "static/Zocial-5cdf883b18a5651a29a4d1ef276d2457.ttf";